import React from "react";

import { MultiplyIcon } from "shared/components";
import { Spacer } from "shared/layout";
import { IDimensions } from "Venues/types";
import { Distance, DistanceUnit, DistanceUnits } from "shared/utils";

interface DimensionsProps {
  dimensions: IDimensions;
  toUnit?: DistanceUnit;
}

export const Dimensions: React.FC<DimensionsProps> = ({ dimensions, toUnit = DistanceUnits.m }) => {
  const { width, height, depth } = dimensions;

  return (
    <Spacer size="xxs" spaceDirection="horizontal" align="center">
      <span>{new Distance(width || 0, DistanceUnits.mm).convert(toUnit).toString()}</span>
      <MultiplyIcon />
      <span>{new Distance(height || 0, DistanceUnits.mm).convert(toUnit).toString()}</span>
      <MultiplyIcon />
      <span>{new Distance(depth || 0, DistanceUnits.mm).convert(toUnit).toString()}</span>
    </Spacer>
  );
};
